var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenInNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.27244 18C1.86776 18 1.51366 17.85 1.21015 17.55C0.906638 17.25 0.754883 16.9 0.754883 16.5V1.5C0.754883 1.1 0.906638 0.75 1.21015 0.45C1.51366 0.15 1.86776 0 2.27244 0H9.32906V1.5H2.27244V16.5H17.448V9.525H18.9655V16.5C18.9655 16.9 18.8138 17.25 18.5103 17.55C18.2067 17.85 17.8526 18 17.448 18H2.27244ZM7.38153 12.525L6.31924 11.45L16.3857 1.5H10.8466V0H18.9655V8.025H17.448V2.575L7.38153 12.525Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenInNewTab);
export default __webpack_public_path__ + "static/media/open-in-new-tab.12afcb94ed12749c21f1fdab2d15129d.svg";
export { ForwardRef as ReactComponent };